import { DateTime } from "luxon";

export interface IValueFormatter {
  (params: { cellValue: any; row: any }): string | undefined;
}

export const defaultFormatter: IValueFormatter = (params: {
  cellValue: any;
}) => {
  return params.cellValue?.toString();
};

export const numberFormatterFactory: (config?: {
  decimalPlaces?: number;
}) => IValueFormatter = (config) => {
  return (params) => params.cellValue?.toFixed(config?.decimalPlaces ?? 3);
};

export const decoratedNumberFormatterFactory: (config: {
  suffix?: string;
  prefix?: string;
  decimalPlaces?: number;
}) => IValueFormatter = (config) => {
  const baseFormatter = numberFormatterFactory({
    decimalPlaces: config.decimalPlaces,
  });
  return (params) => {
    let finalValue = baseFormatter(params);
    if (finalValue === undefined) {
      return undefined;
    }
    if (config.suffix) {
      finalValue = finalValue + config.suffix;
    }
    if (config.prefix) {
      finalValue = config.prefix + finalValue;
    }

    return finalValue;
  };
};

export const currencyFormatter: IValueFormatter =
  decoratedNumberFormatterFactory({ decimalPlaces: 2, prefix: "$" });
export const percentageFormatter: IValueFormatter =
  decoratedNumberFormatterFactory({ decimalPlaces: 3, suffix: "%" });

export const booleanFormatterFactory: (config?: {
  trueValue?: string;
  falseValue?: string;
}) => IValueFormatter = (config) => {
  const trueValue = config?.trueValue ?? "Yes";
  const falseValue = config?.falseValue ?? "No";

  return (params) => (Boolean(params.cellValue) ? trueValue : falseValue);
};

export const dateFormatterFactory: (config?: {
  options?: Intl.DateTimeFormatOptions;
}) => IValueFormatter = (config) => {
  return function (params) {
    const { cellValue } = params;

    if (!cellValue) return undefined;

    const luxonObject =
      cellValue instanceof Date
        ? DateTime.fromJSDate(cellValue)
        : DateTime.fromISO(cellValue);
    return luxonObject.toLocaleString(config?.options ?? DateTime.DATE_SHORT);
  };
};
